module.exports = __webpack_public_path__ + "img/across shoulders.33cba72a.png";